export interface LinkOptions {
    [key: string]: string;
}

export interface LinkConfig {
    legacyLink: string;
    mfeLink: string;
    shouldUseMFE: boolean;
    ariaLabel?: string;
}

export const substituteArgument = (link: string, options?: LinkOptions) => {
    if (options != null && options != undefined) {
        Object.keys(options).forEach(key => {
            link = link.replace(`{{${key}}}`, options[key]);
        });
    }
    return link;
};

// Maintaining this make it evident that this is for MFEs, though it is a mere passthrough, for now.
export const buildMfeLink = (mfeLink: string, options?: LinkOptions) =>
    substituteArgument(mfeLink, options);

export const buildLegacyLink = (legacyLink: string, options?: LinkOptions) =>
    substituteArgument(`${process.env.AUCTIONS_HOMEPAGE_URL}${legacyLink}`, options);
